// extracted by mini-css-extract-plugin
module.exports = {"touchable":"touchable_touchable__tigv0","touchableButton":"touchable_touchableButton__3WHbt"};